export default "__VITE_ASSET__CQPHF2p1__"